module.exports = __webpack_public_path__ + "img/walter_zingg.9513ee26.jpeg";